﻿import { global } from "../Common/saop-common";
import { SaopViewForm } from "../Core/saop-view-form";

export class KEEmployeeGradesEditView extends SaopViewForm {

    constructor(viewId:string,libName:string = ""){
        super(viewId, libName);
        this.setDictionary(); 
        this.title = "";
        this.addRecordEndpoint = "";
        this.editRecordEndpoint = "KeAllEmployeesGradesAdministration/EditEmployeeGrades";
        this.deleteRecordEndpoint = ""; 
    }

    setDictionary(){
        this.setTerminologyList();
    } 

    public afterViewShowSuccess(sender:any):void{
        this.LoadViewEvents();
    }

    public LoadViewEvents ():void{
        let _viewDiv = $(this.id);
        if (_viewDiv.length == 0) {
            return;
        }
    }

    showForm(data: any, title: string): void {
        global.ConsoleLogDegug("KEEmployeeGradesEditView.showForm");

        this.title = title;
        this.editRecord(data);
        this.SetToFullScreen(); 

        this.viewShowComplete = this.initForm.bind(this);
    }

    initForm(): void {
        global.ConsoleLogDegug("KEEmployeeGradesEditView.initForm");
    }
  //
}






